import React from 'react';
import './confirmation_window.scss';

class ConfirmationWindow extends React.Component {
  getIcon() {
    if(this.props.loading) {
      return (
        <div key="confirm_window_confirm_icon">
          <i className="fas fa-spinner confirmation-window__loading-icon"></i>
        </div>
      );
    }
    else if(this.props.useSuccessIcon) {
      return (
        <div key="confirm_window_success_icon">
          <i className="fas fa-circle-check confirmation-window__success-icon"></i>
        </div>
      );
    }
    else if(this.props.useErrorIcon) {
      return (
        <div key="confirm_window_error_icon">
          <i className="fas fa-times confirmation-window__error-icon"></i>
        </div>
      );
    }

    return (
      <div key="confirm_window_alert_icon">
        <i className="fas fa-exclamation-circle confirmation-window__alert-icon"></i>
      </div>
    );
  }

  render() {
    if (this.props.visible) {
      return (
        <div key="confirmation_window" className="confirmation-window__pose-wrapper">

          <aside className={`confirmation-window${this.props.className ? ` ${this.props.className}` : ''}`}>

            <div className="confirmation-window__container">

              <div className="confirmation-window__icon-wrapper">

                {this.getIcon()}

              </div>

              <h2 className={`confirmation-window__title${this.props.loading ? '--pulsing' : ''}`}>

                {this.props.title}

              </h2>

              {this.props.descriptionAsElement ? this.props.description : (
                <p className="confirmation-window__description">

                  {this.props.description}

                </p>
              )}

              {!this.props.loading &&
                <div
                  key="confirmation_window__buttons"
                  className="confirmation-window__controls-wrapper"
                >

                  {!this.props.hideCancelButton &&
                    <button
                      className="confirmation-window__cancel-button"
                      onClick={() => this.props.onCancel()}
                    >

                      {this.props.cancelText || 'Cancelar'}

                    </button>
                  }

                  {!this.props.hideConfirmButton &&
                    <button
                      className="confirmation-window__confirm-button"
                      onClick={() => this.props.onConfirm()}
                    >

                      {this.props.confirmText || 'Confirmar'}

                    </button>
                  }

                </div>
              }

            </div>

          </aside>

        </div>
      );
    }
  }
}

export default ConfirmationWindow;
